import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=13c2e59f&"
import script from "./Card.vue?vue&type=script&lang=coffee&"
export * from "./Card.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports